import { getContentByRef } from "./get-content-by-ref.js";
import { getPageRoot } from "./get-page-root.js";
const getReturnReasons = (pageModel, refPrefix) => {
  if (!pageModel) {
    return;
  }
  const pageRoot = getPageRoot(pageModel, refPrefix);
  const ref = pageRoot?.models?.returnsConfiguration?.$ref;
  const content = getContentByRef(ref, pageModel, refPrefix);
  if (!content) {
    console.warn(`Cannot find content for Returns Configuration. Got: ${content} for $ref: ${ref}`);
    return;
  }
  const reasons = content.data.keyValue.map(({ key, value }) => {
    return {
      key,
      value
    };
  });
  return reasons;
};
export {
  getReturnReasons
};
//# sourceMappingURL=get-return-reasons.js.map
